import DateTimePicker from "react-datetime-picker";

export default function ShipmentEditForm(props: {
    isCreate: boolean;
    trackingNumber: string;
    memo: string;
    initialStatusDescription?: string;
    initialStatusLocation?: string;
    initialStatusTime?: Date | null;
    setTrackingNumber?: (trackingNumber: string) => void;
    setMemo: (memo: string) => void;
    setInitialStatusDescription?: (initialStatusDescription: string) => void;
    setInitialStatusLocation?: (initialStatusLocation: string) => void;
    setInitialStatusTime?: (initialStatusTime: Date | null) => void;
}) {
    return (
        <>
            <div className='row'>
                {props.isCreate ?
                <div className="col-12 mb-3">
                    <label htmlFor="tracking-number" className="form-label">Tracking Number</label>
                    <input className="form-control" name="tracking-number" required={true} maxLength={20} value={props.trackingNumber} onChange={(e) => props.setTrackingNumber?.(e.target.value)} />
                </div>
                : <div className="col-12 mb-3">
                    <label className="form-label">Tracking Number</label>
                    <p>{props.trackingNumber}</p>
                </div>}
            </div>
            
            <div className='row'>
                <div className="col-12 mb-3">
                    <label htmlFor="memo" className="form-label">Memo</label>
                    <textarea className="form-control" name="memo" cols={3} placeholder="Enter any text which you may find helpful. This data is only exposed to administrators." value={props.memo} onChange={(e) => props.setMemo(e.target.value)} />
                </div>
            </div>
            {props.isCreate
                && props.setInitialStatusTime !== undefined
                && props.setInitialStatusDescription !== undefined
                && props.setInitialStatusLocation !== undefined
                && <>
                    <div className='row'>
                        <h3 className='col-12'>Initial Update</h3>
                    </div>
                    <div className='row'>
                        <div className="col-12 mb-3">
                            <label htmlFor="initial-update-description" className="form-label">Description</label>
                            <input className="form-control" name="initial-update-description" maxLength={2500} value={props.initialStatusDescription} onChange={(e) => props.setInitialStatusDescription?.(e.target.value)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 mb-3">
                            <label htmlFor="initial-update-location" className="form-label">Location</label>
                            <input className="form-control" name="initial-update-location" maxLength={2500} value={props.initialStatusLocation} onChange={(e) => props.setInitialStatusLocation?.(e.target.value)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 mb-3">
                            <label htmlFor="company-name" className="form-label">Update Time</label>
                            <DateTimePicker className="form-control" name="initial-update-time" value={props.initialStatusTime} onChange={props.setInitialStatusTime} />
                        </div>
                    </div>
                </>}
        </>
    );
}